import { View } from "react-native";

import { KeyboardFocusViewProps } from "./KeyboardFocusView.types";

declare const KeyboardFocusView: React.ForwardRefExoticComponent<
  KeyboardFocusViewProps & React.RefAttributes<View>
>;
